import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { SalesRepositoryToken } from '../../di/tokens';
import type { SalesEntityType } from '../../domain/entities/sales.entity';

/**
 * Histórico paginado de `EntityEvent` de qualquer entidade auditável do Sales
 * (Contract/BillingAgreement/Invoice/DebtArrangement), mais recentes primeiro.
 * Só dispara quando `enabled` (modal aberto).
 */
export function useEntityEvents(
  entityType: SalesEntityType,
  entityId: string,
  page: number,
  perPage: number,
  enabled = true,
) {
  const repository = container.resolve(SalesRepositoryToken);
  return useQuery({
    queryKey: ['sales', 'entity-events', entityType, entityId, page, perPage],
    queryFn: () =>
      repository.getEntityEvents(entityType, entityId, { page, perPage }),
    enabled: !!entityId && enabled,
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
    retry: false,
  });
}
